/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrderInfoForSplitGoodsInfoForSplitVo
 */
export interface OrderInfoForSplitGoodsInfoForSplitVo {
    /**
     * 商品关联的通关类目ID
     * @type {number}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    ctmsItemId?: number;
    /**
     * 通关类目名称，按当前语言展示，与订单列表一致
     * @type {string}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    ctmsItemName?: string;
    /**
     * 历史商品关联的SKU ID
     * @type {number}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    skuId?: number;
    /**
     * SKU 展示编码，与数据库 SKU 主键区分。
     * @type {string}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    skuCode?: string;
    /**
     * 历史商品英文名称
     * @type {string}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    nameEn?: string;
    /**
     * 历史商品单价币种
     * @type {string}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    currencyCode?: string;
    /**
     * 商品ID
     * @type {number}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    id?: number;
    /**
     * 商品单价
     * @type {number}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    unitPrice?: number;
    /**
     * 商品总价
     * 商品总价(韩元)
     * @type {number}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    totalPriceKrw?: number;
    /**
     * 商品总价(美元)
     * @type {number}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    totalPriceUsd?: number;
    /**
     * 商品链接  没有就用空字符串
     * 商品链接
     * @type {string}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    url?: string;
    /**
     * 商品图片链接
     * @type {string}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    imgUrl?: string;
    /**
     * 颜色
     * @type {string}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    color?: string;
    /**
     * 尺寸
     * @type {string}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    size?: string;
    /**
     * 市场条码
     * @type {string}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    marketBarcode?: string;
    /**
     * 市场商品名称
     * @type {string}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    marketProNm?: string;
    /**
     * 市场选项名称
     * @type {string}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    marketOptionName?: string;
    /**
     * 市场选项ID
     * @type {string}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    marketOptionId?: string;
    /**
     * CO商品名称（英文）
     * @type {string}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    coGoodsNameEn?: string;
    /**
     * CO海关编码
     * @type {string}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    coHsCode?: string;
    /**
     * 是否为合包商品 0 不是，1 是  （0是基础商品，1 是合包商品）
     * 是否为合包商品
     * @type {number}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    combined?: number;
    /**
     * 商品初始数量  分单的时候，要是分商品，那商品可用数量和初始数量都要减
     * 商品初始数量
     * @type {number}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    initQuantity?: number;
    /**
     * 商品可用数量
     * @type {number}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    availableQuantity?: number;
    /**
     * 是否为快递件商品：0 否，1 是
     * @type {number}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    simple?: number;
    /**
     * 商品编码
     * @type {string}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    code?: string;
    /**
     * 商品总价(人民币)
     * @type {number}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    totalPriceCny?: number;
    /**
     * 商品构成
     * @type {number}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    constructCount?: number;
    /**
     * 快递单号
     * @type {string}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    trackingNumbers?: string;
    /**
     * 货位
     * @type {string}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    locationNos?: string;
    /**
     * 基础商品列表
     * @type {Array<OrderInfoForSplitGoodsInfoForSplitVo>}
     * @memberof OrderInfoForSplitGoodsInfoForSplitVo
     */
    baseGoods?: Array<OrderInfoForSplitGoodsInfoForSplitVo>;
}

/**
 * Check if a given object implements the OrderInfoForSplitGoodsInfoForSplitVo interface.
 */
export function instanceOfOrderInfoForSplitGoodsInfoForSplitVo(value: object): value is OrderInfoForSplitGoodsInfoForSplitVo {
    return true;
}

export function OrderInfoForSplitGoodsInfoForSplitVoFromJSON(json: any): OrderInfoForSplitGoodsInfoForSplitVo {
    return OrderInfoForSplitGoodsInfoForSplitVoFromJSONTyped(json, false);
}

export function OrderInfoForSplitGoodsInfoForSplitVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderInfoForSplitGoodsInfoForSplitVo {
    if (json == null) {
        return json;
    }
    return {
        
        'ctmsItemId': json['ctmsItemId'] == null ? undefined : json['ctmsItemId'],
        'ctmsItemName': json['ctmsItemName'] == null ? undefined : json['ctmsItemName'],
        'skuId': json['skuId'] == null ? undefined : json['skuId'],
        'skuCode': json['skuCode'] == null ? undefined : json['skuCode'],
        'nameEn': json['nameEn'] == null ? undefined : json['nameEn'],
        'currencyCode': json['currencyCode'] == null ? undefined : json['currencyCode'],
        'id': json['id'] == null ? undefined : json['id'],
        'unitPrice': json['unitPrice'] == null ? undefined : json['unitPrice'],
        'totalPriceKrw': json['totalPriceKrw'] == null ? undefined : json['totalPriceKrw'],
        'totalPriceUsd': json['totalPriceUsd'] == null ? undefined : json['totalPriceUsd'],
        'url': json['url'] == null ? undefined : json['url'],
        'imgUrl': json['imgUrl'] == null ? undefined : json['imgUrl'],
        'color': json['color'] == null ? undefined : json['color'],
        'size': json['size'] == null ? undefined : json['size'],
        'marketBarcode': json['marketBarcode'] == null ? undefined : json['marketBarcode'],
        'marketProNm': json['marketProNm'] == null ? undefined : json['marketProNm'],
        'marketOptionName': json['marketOptionName'] == null ? undefined : json['marketOptionName'],
        'marketOptionId': json['marketOptionId'] == null ? undefined : json['marketOptionId'],
        'coGoodsNameEn': json['coGoodsNameEn'] == null ? undefined : json['coGoodsNameEn'],
        'coHsCode': json['coHsCode'] == null ? undefined : json['coHsCode'],
        'combined': json['combined'] == null ? undefined : json['combined'],
        'initQuantity': json['initQuantity'] == null ? undefined : json['initQuantity'],
        'availableQuantity': json['availableQuantity'] == null ? undefined : json['availableQuantity'],
        'simple': json['simple'] == null ? undefined : json['simple'],
        'code': json['code'] == null ? undefined : json['code'],
        'totalPriceCny': json['totalPriceCny'] == null ? undefined : json['totalPriceCny'],
        'constructCount': json['constructCount'] == null ? undefined : json['constructCount'],
        'trackingNumbers': json['trackingNumbers'] == null ? undefined : json['trackingNumbers'],
        'locationNos': json['locationNos'] == null ? undefined : json['locationNos'],
        'baseGoods': json['baseGoods'] == null ? undefined : ((json['baseGoods'] as Array<any>).map(OrderInfoForSplitGoodsInfoForSplitVoFromJSON)),
    };
}

export function OrderInfoForSplitGoodsInfoForSplitVoToJSON(json: any): OrderInfoForSplitGoodsInfoForSplitVo {
    return OrderInfoForSplitGoodsInfoForSplitVoToJSONTyped(json, false);
}

export function OrderInfoForSplitGoodsInfoForSplitVoToJSONTyped(value?: OrderInfoForSplitGoodsInfoForSplitVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ctmsItemId': value['ctmsItemId'],
        'ctmsItemName': value['ctmsItemName'],
        'skuId': value['skuId'],
        'skuCode': value['skuCode'],
        'nameEn': value['nameEn'],
        'currencyCode': value['currencyCode'],
        'id': value['id'],
        'unitPrice': value['unitPrice'],
        'totalPriceKrw': value['totalPriceKrw'],
        'totalPriceUsd': value['totalPriceUsd'],
        'url': value['url'],
        'imgUrl': value['imgUrl'],
        'color': value['color'],
        'size': value['size'],
        'marketBarcode': value['marketBarcode'],
        'marketProNm': value['marketProNm'],
        'marketOptionName': value['marketOptionName'],
        'marketOptionId': value['marketOptionId'],
        'coGoodsNameEn': value['coGoodsNameEn'],
        'coHsCode': value['coHsCode'],
        'combined': value['combined'],
        'initQuantity': value['initQuantity'],
        'availableQuantity': value['availableQuantity'],
        'simple': value['simple'],
        'code': value['code'],
        'totalPriceCny': value['totalPriceCny'],
        'constructCount': value['constructCount'],
        'trackingNumbers': value['trackingNumbers'],
        'locationNos': value['locationNos'],
        'baseGoods': value['baseGoods'] == null ? undefined : ((value['baseGoods'] as Array<any>).map(OrderInfoForSplitGoodsInfoForSplitVoToJSON)),
    };
}

